import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams } from '@/types';
import { IPlayerOnlineApiListResponse, IPlayerOnlineLogoutParams, IPlayerOnlineReloadParams } from '@/types/playerOnline';

export const playerOnlineList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IPlayerOnlineApiListResponse>> => {
    return axios.get('/api/playerOnline/list', { ...config, params });
};

export const playerOnlineReload = (params: IPlayerOnlineReloadParams): Promise<AxiosResponse<{ success: boolean }>> => {
    return axios.post('/api/playerOnline/reload', params);
};

export const playerOnlineLogout = (params: IPlayerOnlineLogoutParams): Promise<AxiosResponse<{ success: boolean }>> => {
    return axios.post('/api/playerOnline/logout', params);
};
